import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConstantService } from "app/Shared/Services/constant-service";
import { UserService } from "app/Shared/Services/user.service";
import { JsonViewerService } from "./json-viewer.service";
import { CommonModule } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTooltipModule } from "@angular/material/tooltip";
import saveAs from "file-saver";
import { ButtonModule } from "primeng/button";
import { TableModule } from "primeng/table";
import { MatTabsModule } from "@angular/material/tabs";
import { CompareJsonComponent } from "./compare-json.component";
import { FormatterComponent } from "./json-formatter.component";
import { PrettyJsonPipe } from "../pipes/prettyjson.pipe";
import { DrawerModule } from "primeng/drawer";

@Component({
    selector: 'app-json-viewer-dialog',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        DrawerModule, MatTabsModule, FormatterComponent, CompareJsonComponent, PrettyJsonPipe],
    template: `
  <p-drawer header="" id="json-viewer" 
  [(visible)]="isOpenClose" 
  position="right" 
  [baseZIndex]="10000" 
  (onHide)="closeDialogbox()"
  [style]="{'width':'auto','max-width': '920px','height':'auto','overflow-y': 'auto','max-height':'100%','padding':'0px','margin':'0px'}"
  appendTo="body"
  styleClass = "json-viewer-sidebar">
  <div class="col-md-12 nopadding container">
    <mat-tab-group dynamicHeight>
      <mat-tab label="Compare">
      <div class="example-large-box mat-elevation-z4">
        <div class="col-md-6 nopadding container">
          <h4 class="nopadding"> Original JSON</h4>
          <pre><app-compare-json class="removespace" [originalJSONObject]="(originalJSONObject)"  [selectedJSONObject]="(selectedJSONObject)"></app-compare-json></pre>
        </div>
        <div class="col-md-6 nopadding container">
          <h4 class="nopadding"> Selected JSON</h4>
          <pre><app-compare-json class="removespace" [originalJSONObject]="(selectedJSONObject)"  [selectedJSONObject]="(originalJSONObject)"></app-compare-json></pre>
        </div>
      </div>
      </mat-tab>
      <mat-tab label="Beautify">
        <div class="example-large-box mat-elevation-z4">
          <div class="col-md-6 nopadding container">
            <h4 class="nopadding"> Original JSON</h4>
            <pre [innerHTML]="(originalJSONObject) | prettyjson: [false, 3]"></pre>
          </div>
          <div class="col-md-6 nopadding container">
            <h4 class="nopadding"> Selected JSON</h4>
            <pre [innerHTML]="(selectedJSONObject) | prettyjson: [false, 3]"></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Tree Viewer">
        <div class="example-large-box mat-elevation-z4">
          <div class="col-md-6 nopadding container">
            <h4 class="nopadding"> Original JSON</h4>
            <pre><app-json-formatter [data]="(originalJSONObject)"></app-json-formatter></pre>
          </div>
          <div class="col-md-6 nopadding container">
            <h4 class="nopadding"> Selected JSON</h4>
            <pre><app-json-formatter [data]="(selectedJSONObject)"></app-json-formatter></pre>
          </div>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
    <ng-template #footer>
  <button type="button" matTooltip="Export JSON" [matTooltipShowDelay]="1000" id="export-json-viewer" label="export-json" class="exportBtn"
  (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
  </button>
  </ng-template>
</p-drawer>

`,
    styles: [`
  .container {
                max-width: 100% !important;
                min-height: 350px !important;
                z-index: 1006 !important;
                opacity: 1 !important;
                }
  p {
      font-family: Lato !important;
    }
  
    .removespace {
      margin:0px;
      padding:0px;
      white-space:initial !important
    }    
      
    .mat-chip:not(.mat-basic-chip) {
      background-color: #3f51b5;
      color: white;
      transition: box-shadow 280ms cubic-bezier(.4,0,.2,1);
      display: inline-flex;
      padding: 2px 11px;
      border-radius: 24px;
      align-items: center;
      cursor: pointer!important;
    }
    ::ng-deep  .mat-tab-label {
      height: 23px!important;
      padding: 0 24px;
      cursor: pointer;
      box-sizing: border-box;
      opacity: .8!important;
    }
    .exportBtn{
      float:right;
      margin-right: 8px;
      margin-bottom:-10px;
    }

    ::ng-deep .json-viewer-sidebar .p-sidebar-header {
      padding: 1rem;
    }

    ::ng-deep .json-viewer-sidebar {
      width: auto !important;
    }
    ::ng-deep .json-viewer-sidebar .p-button.p-button-icon-only{
      font-size: 12px !important;
      background: #fff !important;
      border: none !important;
}

    ::ng-deep .json-viewer-sidebar .p-sidebar-content {
      padding: 0px;
    }

    ::ng-deep .mat-mdc-tab-body {
      padding: 7px;
    }

    ::ng-deep .mat-mdc-tab-label-container {
      border-bottom: 1px solid rgba(0,0,0,.12) !important;
    }

    h4 {
      font-size: 18px;
      font: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;
      color: #222222;
    }
    ::ng-deep .json-viewer-sidebar .p-drawer-content{
      padding: 0px !important;
      margin-top: -8px !important;
    }

  `]
})
export class JSONViewerComponent implements OnInit {
  @Output() closeEventDialog: EventEmitter<boolean> = new EventEmitter();
  @Input('selectedJSONObject') selectedJSONObject: any;
  @Input('originalJSONObject') originalJSONObject: any;
  @Input('isJSONViewerOpen') isOpenClose: boolean = false;
  @Input() activeFilter: string = "Beautify";
  messageService: any;

  constructor(public constantService: ConstantService,
    public jsonViewerService: JsonViewerService,
    private userService: UserService,
    private element: ElementRef) {

  }
  closeDialogbox() {
    this.isOpenClose = false;
    this.closeEventDialog.emit(true);
  }
  ngOnInit() {
    this.originalJSONObject = this.jsonViewerService.formatJSON(this.originalJSONObject);
    this.selectedJSONObject = this.jsonViewerService.formatJSON(this.selectedJSONObject);
  }

  ngOnChanges() {
  }
  
  exportToCSV() {
    const filename = 'RSMS_JSON_Viewer_' + (this.originalJSONObject['type'] ? this.originalJSONObject['type'] + '_' : '') + (this.originalJSONObject['firmROEID'] ? this.originalJSONObject['firmROEID'] + '_' : '') + this.userService.getyyyyMMddDateFormate(new Date())+'.json';
    let dataArray: any[] = [];
    dataArray.push(JSON.stringify(this.originalJSONObject)+"\n");
    dataArray.push(JSON.stringify(this.selectedJSONObject)+"\n");
    const blob = new Blob([dataArray+""], { type: 'application/octet-stream' });
    saveAs(blob, filename);
  }
}